<ng-container *ngLet="(breadcrumbs$ | async) as breadcrumbs">
	<div [matTooltip]="tooltip$ | async"
		 class="ui-breadcrumbs-path">
		<ng-container *ngLet="pageScopeIcon$ | async as scope">
			<mat-icon *ngIf="scope === PageScope.Global"
					  svgIcon="uipath:global"></mat-icon>
			<mat-icon *ngIf="scope === PageScope.Folder">folder</mat-icon>
		</ng-container>
		<span *ngFor="let b of breadcrumbs;">
			<span class="{{'ui-breadcrumb-' + b.type}}">
				{{ b.value }}
			</span>
		</span>
	</div>
</ng-container>
